import metadataModal from "./metadata-modal/metadata-modal";
import template from "./report-export-actions.html";
import "./report-export-actions.less";

function controller(
	$logger,
	$uibModal
) {
	const ctrl = this;

	ctrl.$onInit = () => {
	};

	ctrl.viewMetadata = () => {
		openMetadataModal();
	};

	async function openMetadataModal() {
		$uibModal.open({
			component: "metadata-modal",
			size: "lg",
			backdrop: "static",
			resolve: {
				reportExport: () => ctrl.reportExport
			}
		});
	}
}

export default angular
	.module("vesl.components.report-export-actions", [metadataModal])
	.component("reportExportActions", {
		template,
		transclude: true,
		controller,
		bindings: {
			reportExport: "<"
		}
	}).name;
